export default "__VITE_ASSET__DKKkdvsq__"